var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCampaignFlow = function SvgIconCampaignFlow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "450px",
    height: "140px",
    viewBox: "0 0 450 140",
    style: {
      enableBackground: "new 0 0 450 140"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;fill:#55C81E;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F5A623;}\n\t.st3{fill:#55C81E;}\n\t.st4{fill:#FFFFFF;stroke:#000001;stroke-miterlimit:10;}\n\t.st5{fill:#55C81E;stroke:#000001;stroke-miterlimit:10;}\n\t.st6{fill:#55C81E;stroke:#55C81E;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1887",
    transform: "translate(-21 -767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1595",
    transform: "translate(19.961 765.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10281",
    className: "st3",
    d: "M164.1,41.6c-0.4-5-5.8-7.9-6.4-8.2l0,0c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.1-0.6-0.2-0.9-0.2 h-23.8c4.9-20.5-6.4-28.4-6.9-28.8l-0.3-0.2c-2.5-1.3-5.3-1.6-8-0.7c-1.8,0.6-3.2,1.9-4.1,3.6l0,0c-0.2,0.4-0.3,0.8-0.3,1.2v13 c-1.1,3.8-4.8,10.7-10.2,19l-0.2,0.3c-0.8,1.3-0.5,2.9,0.8,3.8c0.6,0.4,1.3,0.5,2,0.4c0.7-0.2,1.3-0.6,1.7-1.2 c0.1-0.1,9.2-13.9,11.1-21.2c0.1-0.2,0.1-0.5,0.1-0.8V9.1c1.1-1.2,2.9-0.7,4.4,0c1.8,1.4,9.1,8.6,3.6,26c-0.3,0.8-0.1,1.7,0.4,2.4 c0.5,0.7,1.3,1.1,2.2,1.1h26.7c1.4,0.9,2.9,2.2,3,3.5s-1,2.8-3.2,4.4h-4.2c-1.5,0-2.7,1.2-2.8,2.6c0,1.5,1.2,2.7,2.6,2.8 c0,0,0.1,0,0.1,0h5c0.5,0,1.1-0.2,1.5-0.5C162.4,48.4,164.4,45.1,164.1,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10282",
    className: "st3",
    d: "M158,53.1L158,53.1c-1.5-0.2-2.8,0.9-3,2.3c0,0,0,0,0,0.1c-0.2,1.1-0.8,2.2-1.7,2.9 c-1.4,0.7-3,0.8-4.4,0.3c-0.7-0.2-1.4,0-2,0.3c-1.3,0.8-1.7,2.5-0.9,3.8c0.4,0.6,1,1,1.7,1.2c1.1,0.3,2.3,0.4,3.4,0.5 c1.9,0,3.8-0.5,5.4-1.6c2.2-1.6,3.6-4,3.9-6.7c0.1-0.7-0.1-1.4-0.5-1.9C159.5,53.6,158.8,53.2,158,53.1L158,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10283",
    className: "st3",
    d: "M154.8,65.6L154.8,65.6c-0.7-0.1-1.3,0.2-1.8,0.6c-0.6,0.5-0.9,1.2-1,2c-0.1,0.8-0.4,1.5-1,2 c-1.1,0.6-2.4,0.7-3.6,0.3c-1.5-0.3-2.9,0.7-3.2,2.2c-0.1,0.7,0,1.3,0.3,1.9c0.4,0.6,1,1,1.7,1.2c0.9,0.2,1.9,0.3,2.9,0.3 c1.9,0.1,3.7-0.5,5.2-1.7c1.8-1.5,2.9-3.7,3-6c0-0.7-0.2-1.4-0.7-1.9C156.2,65.9,155.5,65.6,154.8,65.6L154.8,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10284",
    className: "st3",
    d: "M151.4,77.5c-0.1,0-0.1,0-0.2,0c-0.6,0-1.2,0.3-1.7,0.7c-0.5,0.5-0.9,1.2-0.9,1.9 c0,0.1-0.3,3.1-6.6,3.4h-36.8c-1.5-0.1-2.8,0.9-3,2.4c-0.1,1.5,0.9,2.8,2.4,3c0.2,0,0.4,0,0.5,0h36.9c11.8-0.5,11.9-8.6,11.9-8.7 C154,78.8,152.9,77.6,151.4,77.5L151.4,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10285",
    className: "st3",
    d: "M96.7,39.6h-18c-1.5,0-2.7,1.2-2.8,2.6c0,1.5,1.2,2.7,2.6,2.8c0,0,0.1,0,0.1,0h15.1 l-0.2,40.6H60.1c-1.5,0-2.7,1.2-2.8,2.6S58.5,91,60,91c0,0,0.1,0,0.1,0h36.2c1.5,0,2.7-1.2,2.7-2.7l0.3-46 C99.2,40.9,98.2,39.8,96.7,39.6L96.7,39.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11801",
    className: "st3",
    d: "M242.6,864.6v-16.1h-16.5v-10.7h16.1v-16.1h10.7v16.1h16.1v10.7h-16.1v16.1L242.6,864.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1884",
    transform: "translate(138.001 843.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11744",
    className: "st3",
    d: "M172.1,44.5V32.3h3.3v12.2L172.1,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11745",
    className: "st3",
    d: "M185,44.5l-4.3-8.3h0l0.1,8.3h-3V32.3h4.1l4.1,8.3h0l-0.1-8.3h3v12.2L185,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11746",
    className: "st3",
    d: "M191.5,41.5c1,0.5,2.2,0.8,3.3,0.8c1.4,0,2-0.4,2-1.2c0-0.8-0.7-1.2-2.1-1.6 c-2.1-0.6-3.6-1.3-3.6-3.7c0-2.4,2-3.7,5.3-3.7c1.1,0,2.1,0.1,3.1,0.5l-0.2,2.5c-0.9-0.4-1.8-0.6-2.7-0.6c-1.4,0-2.2,0.3-2.2,1.1 c0,0.8,1,1.1,2.4,1.5c2.4,0.6,3.4,1.7,3.4,3.6c0,2.7-1.9,4-5.4,4c-1.2,0-2.5-0.2-3.6-0.5L191.5,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11747",
    className: "st3",
    d: "M204.2,44.5v-9.8h-3v-2.4h9.3v2.4h-3v9.8H204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11748",
    className: "st3",
    d: "M219.3,44.5l-0.9-2.6h-4.6l-1,2.6h-3.3l4.6-12.2h4l4.7,12.2H219.3z M216.2,34.8L216.2,34.8 l-1.6,4.8h3.1L216.2,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11749",
    className: "st3",
    d: "M232.3,39.7h-1.9v-2.3h5v6.8c-1.5,0.4-3.1,0.6-4.7,0.6c-3.8,0-7-2-7-6.2 c0-4.2,2.7-6.4,7.7-6.4c1.3,0,2.5,0.2,3.7,0.5l-0.3,2.7c-0.9-0.5-1.9-0.8-3-0.8c-3.2,0-4.8,1.5-4.8,3.9c-0.1,2.1,1.5,3.8,3.6,3.9 c0.2,0,0.3,0,0.5,0c0.4,0,0.8-0.1,1.2-0.2L232.3,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11750",
    className: "st3",
    d: "M244.7,44.5l-0.8-2.4c-0.7-2.2-1.2-2.4-2.3-2.4H241v4.8h-3.3V32.3h5.7c2.5,0,4,1.1,4,3.1 c0.1,1.5-0.9,2.8-2.3,3.1v0c0.9,0.2,1.1,0.8,1.6,2.4l1.3,3.6L244.7,44.5z M242,37.4c1.2,0,2.2-0.2,2.2-1.4c0-1-0.9-1.3-2.4-1.3 H241v2.8H242z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11751",
    className: "st3",
    d: "M258.3,44.5l-0.9-2.6h-4.6l-1,2.6h-3.3l4.6-12.2h4l4.7,12.2H258.3z M255.1,34.8L255.1,34.8 l-1.6,4.8h3.1L255.1,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11752",
    className: "st3",
    d: "M275.2,44.5l0.1-9.4h0l-3.1,9.4h-3l-3-9.4h0l0.1,9.4H263V32.3h5.1l2.6,8.1h0l2.7-8.1h4.9 v12.2L275.2,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11753",
    className: "st3",
    d: "M171.9,59.4c0.8,0.3,1.6,0.5,2.4,0.6c1.1,0.1,2.2-0.7,2.3-1.8c0,0,0,0,0-0.1 c0-0.8-0.4-1.4-2.3-2.3c-1.5-0.7-2.8-1.4-2.8-3.3c0-1.9,1.5-3.2,3.7-3.2c0.8,0,1.7,0.1,2.5,0.4l-0.2,1.5c-0.7-0.3-1.4-0.5-2.2-0.5 c-1.3,0-2.1,0.6-2.1,1.6c0,1.1,1.2,1.5,2.2,2c1.3,0.6,2.8,1.4,2.8,3.5c0,2.3-1.6,3.5-4.2,3.5c-0.8,0-1.6-0.2-2.4-0.5L171.9,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11754",
    className: "st3",
    d: "M180.2,55.4c0-3.4,2-6,5.6-6c3.5,0,5.6,2.5,5.6,6c0,3.7-2.2,6-5.6,6 C182.4,61.4,180.2,59,180.2,55.4z M189.7,55.4c0-2.3-1.2-4.6-3.9-4.6c-2.5,0-3.8,2.1-3.8,4.6c0,2.6,1.4,4.6,3.8,4.6 C188.3,59.9,189.7,57.9,189.7,55.4L189.7,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11755",
    className: "st3",
    d: "M201,61.2l-5.3-9.6h0v9.6H194V49.5h2.3l5.2,9.4h0v-9.4h1.7v11.7H201z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11756",
    className: "st3",
    d: "M206.2,61.2V49.5h3.4c3.5,0,6.2,2.2,6.2,5.8c0,3.8-2.3,5.9-6.2,5.9L206.2,61.2z M209.6,59.7 c2.5,0,4.4-1.1,4.4-4.4c0.1-2.2-1.6-4.2-3.8-4.3c-0.2,0-0.3,0-0.5,0h-1.9v8.7H209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11757",
    className: "st3",
    d: "M218.6,61.2V49.5h6.5V51h-4.9v3.4h4.4v1.5h-4.4v3.8h4.9v1.5H218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11758",
    className: "st3",
    d: "M234.3,61.2l-1.6-3.7c-0.6-1.3-0.9-1.5-1.9-1.5h-1.2v5.2h-1.7V49.5h3.1 c3.2,0,4.3,1.2,4.3,3.2c0,1.4-1,2.5-2.4,2.7v0c0.6,0.2,0.8,0.5,1.2,1.4l2.1,4.4L234.3,61.2z M231,54.5c1.5,0,2.5-0.7,2.5-1.8 c0-1.1-0.8-1.7-2.4-1.7h-1.6v3.5H231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11759",
    className: "st3",
    d: "M238.3,61.2V49.5h3.1c2.8,0,4.3,1.2,4.3,3.5s-1.7,3.5-4.1,3.5H240v4.7H238.3z M241.6,55.1 c1.1,0.1,2.2-0.7,2.3-1.8c0-0.1,0-0.2,0-0.2c0-1.3-1.3-2-2.6-2H240v4.1H241.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11760",
    className: "st3",
    d: "M254.2,61.2l-1.6-3.7c-0.6-1.3-0.9-1.5-1.9-1.5h-1.2v5.2h-1.7V49.5h3.1 c3.3,0,4.3,1.2,4.3,3.2c0,1.4-1,2.5-2.4,2.7v0c0.6,0.2,0.8,0.5,1.2,1.4l2.1,4.4L254.2,61.2z M250.9,54.5c1.5,0,2.5-0.7,2.5-1.8 c0-1.1-0.8-1.7-2.4-1.7h-1.6v3.5H250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11761",
    className: "st3",
    d: "M258.4,61.2V49.5h6.5V51H260v3.4h4.4v1.5H260v3.8h4.9v1.5H258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11762",
    className: "st3",
    d: "M267.8,61.2V49.5h1.7v11.7H267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11763",
    className: "st3",
    d: "M272.2,59.4c0.8,0.3,1.6,0.5,2.4,0.6c1.1,0.1,2.2-0.7,2.3-1.8c0,0,0,0,0-0.1 c0-0.8-0.4-1.4-2.3-2.3c-1.5-0.7-2.8-1.4-2.8-3.3c0-1.9,1.5-3.2,3.7-3.2c0.8,0,1.7,0.1,2.5,0.4l-0.2,1.5c-0.7-0.3-1.4-0.5-2.2-0.5 c-1.3,0-2.1,0.6-2.1,1.6c0,1.1,1.2,1.5,2.2,2c1.3,0.6,2.8,1.4,2.8,3.5c0,2.3-1.6,3.5-4.2,3.5c-0.8,0-1.6-0.2-2.4-0.5L272.2,59.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1885",
    transform: "translate(21 843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11778",
    className: "st3",
    d: "M56.7,45.1V31.9h8.8v2.5h-5.3v2.9h5.1v2.5h-5.1v5.3L56.7,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11779",
    className: "st3",
    d: "M76.1,45.1l-1-2.8h-4.9l-1,2.8h-3.6l5-13.2h4.3L80,45.1H76.1z M72.8,34.6L72.8,34.6L71,39.8 h3.3L72.8,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11780",
    className: "st3",
    d: "M92.8,44.8c-1.3,0.4-2.6,0.5-3.9,0.5c-4.2,0-7.6-2.3-7.6-6.8c0-4.3,2.9-6.9,7.5-6.9 c1.3,0,2.7,0.3,3.9,0.7l-0.3,2.9c-1-0.6-2.2-0.9-3.4-0.9c-2.2-0.1-4.1,1.6-4.1,3.9c0,0.1,0,0.3,0,0.4c-0.1,2.2,1.7,4.1,3.9,4.2 c0.2,0,0.3,0,0.5,0c1.1,0,2.2-0.3,3.3-0.7L92.8,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11781",
    className: "st3",
    d: "M94.7,45.1V31.9h9.3v2.5h-5.8v2.7h5.5v2.5h-5.5v3h6v2.5L94.7,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11782",
    className: "st3",
    d: "M106.7,45.1V31.9h6c2.7,0,4.3,1.2,4.3,3.3c0.1,1.5-0.9,2.8-2.3,3.1v0 c1.8,0.4,2.7,1.3,2.7,2.9c0,2.7-2,3.8-5.1,3.8L106.7,45.1z M111.2,37.1c1.2,0,2.4-0.3,2.4-1.4c0-1.2-1.2-1.3-2.3-1.3h-1v2.7H111.2 z M111.4,42.6c2.2,0,2.5-0.9,2.5-1.5c0-1.3-1-1.6-2.6-1.6h-1.1v3.1L111.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11783",
    className: "st3",
    d: "M119.4,38.5c0-4.3,2.4-6.8,6.6-6.8c4.2,0,6.6,2.5,6.6,6.8s-2.4,6.8-6.6,6.8 C121.8,45.4,119.4,42.8,119.4,38.5z M129,38.5c0-2.6-1.1-4.2-3-4.2c-1.9,0-3,1.6-3,4.2c0,2.4,1,4.2,3,4.2 C127.9,42.7,129,41,129,38.5L129,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11784",
    className: "st3",
    d: "M134.5,38.5c0-4.3,2.4-6.8,6.6-6.8s6.6,2.5,6.6,6.8s-2.4,6.8-6.6,6.8 C136.9,45.4,134.5,42.8,134.5,38.5z M144.1,38.5c0-2.6-1.1-4.2-3-4.2c-1.9,0-3,1.6-3,4.2c0,2.4,1,4.2,3,4.2 C143,42.7,144.1,41,144.1,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11785",
    className: "st3",
    d: "M157.8,45.1l-4.1-6h0v6h-3.5V31.9h3.5v5.4h0l4-5.4h4.2l-4.9,6.1l5.3,7.1L157.8,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11786",
    className: "st3",
    d: "M56.6,60c0.8,0.3,1.6,0.5,2.4,0.6c1.1,0.1,2.2-0.7,2.3-1.8c0,0,0,0,0-0.1 c0-0.8-0.4-1.4-2.3-2.3c-1.5-0.7-2.8-1.4-2.8-3.3c0-1.9,1.5-3.2,3.7-3.2c0.8,0,1.7,0.1,2.5,0.4l-0.2,1.5c-0.7-0.3-1.4-0.5-2.2-0.5 c-1.3,0-2.1,0.6-2.1,1.6c0,1.1,1.2,1.5,2.2,2c1.3,0.6,2.8,1.4,2.8,3.5c0,2.3-1.6,3.5-4.2,3.5c-0.8,0-1.6-0.2-2.4-0.5L56.6,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11787",
    className: "st3",
    d: "M64.8,56c0-3.4,2-6,5.6-6c3.5,0,5.6,2.5,5.6,6c0,3.7-2.2,6-5.6,6S64.8,59.7,64.8,56z  M74.3,56c0-2.3-1.2-4.6-3.9-4.6c-2.5,0-3.8,2.1-3.8,4.6c0,2.6,1.4,4.6,3.8,4.6C72.9,60.6,74.3,58.6,74.3,56L74.3,56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11788",
    className: "st3",
    d: "M85.4,61.9l-5.3-9.6h0v9.6h-1.7V50.2h2.3l5.1,9.4h0v-9.4h1.7v11.7H85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11789",
    className: "st3",
    d: "M90.4,61.9V50.2h3.4c3.5,0,6.2,2.2,6.2,5.8c0,3.8-2.3,5.9-6.2,5.9L90.4,61.9z M93.8,60.4 c2.5,0,4.4-1.1,4.4-4.4c0.1-2.2-1.6-4.2-3.8-4.3c-0.2,0-0.3,0-0.5,0H92v8.7H93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11790",
    className: "st3",
    d: "M102.6,61.9V50.2h6.5v1.5h-4.9v3.4h4.4v1.5h-4.4v3.8h4.9v1.5H102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11791",
    className: "st3",
    d: "M118.2,61.9l-1.6-3.7c-0.6-1.3-0.9-1.5-1.9-1.5h-1.2v5.2h-1.7V50.2h3.1 c3.2,0,4.3,1.2,4.3,3.2c0,1.4-1,2.5-2.4,2.7v0c0.6,0.2,0.8,0.5,1.2,1.4l2.1,4.4H118.2z M114.9,55.2c1.5,0,2.5-0.7,2.5-1.8 c0-1.1-0.8-1.7-2.4-1.7h-1.6v3.5H114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11792",
    className: "st3",
    d: "M122,61.9V50.2h3.1c2.8,0,4.3,1.2,4.3,3.5s-1.7,3.5-4.1,3.5h-1.6v4.7H122z M125.3,55.7 c1.1,0.1,2.2-0.7,2.3-1.8c0-0.1,0-0.2,0-0.2c0-1.3-1.3-2-2.6-2h-1.4v4.1L125.3,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11793",
    className: "st3",
    d: "M137.7,61.9l-1.6-3.7c-0.6-1.3-0.9-1.5-1.9-1.5H133v5.2h-1.7V50.2h3.1c3.2,0,4.3,1.2,4.3,3.2 c0,1.4-1,2.5-2.4,2.7v0c0.6,0.2,0.8,0.5,1.2,1.4l2.1,4.4H137.7z M134.4,55.2c1.5,0,2.5-0.7,2.5-1.8c0-1.1-0.8-1.7-2.4-1.7h-1.6 v3.5H134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11794",
    className: "st3",
    d: "M141.7,61.9V50.2h6.5v1.5h-4.9v3.4h4.4v1.5h-4.4v3.8h4.9v1.5H141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11795",
    className: "st3",
    d: "M150.9,61.9V50.2h1.7v11.7H150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11796",
    className: "st3",
    d: "M155.1,60c0.8,0.3,1.6,0.5,2.4,0.6c1.1,0.1,2.2-0.7,2.3-1.8c0,0,0,0,0-0.1 c0-0.8-0.4-1.4-2.3-2.3c-1.5-0.7-2.8-1.4-2.8-3.3c0-1.9,1.5-3.2,3.7-3.2c0.8,0,1.7,0.1,2.5,0.4l-0.2,1.5c-0.7-0.3-1.4-0.5-2.2-0.5 c-1.3,0-2.1,0.6-2.1,1.6c0,1.1,1.2,1.5,2.2,2c1.3,0.6,2.8,1.4,2.8,3.5c0,2.3-1.6,3.5-4.2,3.5c-0.8,0-1.6-0.2-2.4-0.5L155.1,60z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1886",
    transform: "translate(136.427 654.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11797",
    className: "st6",
    d: "M251.7,201.6c4.7-1.8,8.4-5.5,10.2-10.2c1-2.8,1.6-5.7,1.6-8.7c0.2-4,0.2-5.3,0.2-15.3 c0-10-0.1-11.4-0.3-15.3c-0.1-3-0.6-5.9-1.7-8.6c-1.8-4.7-5.5-8.4-10.2-10.2c-2.8-1-5.7-1.6-8.7-1.6c-4-0.2-5.3-0.2-15.3-0.2 s-11.4,0.1-15.3,0.3c-3,0.1-5.9,0.6-8.6,1.7c-4.7,1.8-8.4,5.5-10.2,10.2c-1,2.8-1.6,5.7-1.6,8.7c-0.2,4-0.2,5.3-0.2,15.3 c0,10,0.1,11.4,0.3,15.3c0.1,3,0.6,5.9,1.7,8.6c1.8,4.7,5.5,8.4,10.2,10.2c2.8,1,5.7,1.6,8.7,1.6c3.9,0.2,5.3,0.2,15.3,0.2 c10.1,0,11.4-0.1,15.3-0.3C246,203.2,248.9,202.6,251.7,201.6z M227.7,199.3c-2.2,0-3.9,0-5.4,0c-5.3,0-6.7,0-9.8-0.2 c-2.5,0-5-0.5-7.3-1.3c-3.6-1.4-6.4-4.2-7.8-7.8c-0.9-2.3-1.4-4.8-1.4-7.3c-0.2-4-0.2-5.2-0.3-15.1s0-11.2,0.2-15.1 c0-2.5,0.5-5,1.3-7.3c1.4-3.6,4.2-6.4,7.8-7.8c2.3-0.9,4.8-1.4,7.3-1.4c4-0.2,5.1-0.2,15.1-0.3c10,0,11.2,0,15.1,0.2 c2.5,0,5,0.5,7.3,1.3c1.8,0.7,3.4,1.7,4.7,3.1c1.4,1.3,2.4,2.9,3.1,4.7c0.9,2.3,1.4,4.8,1.4,7.3c0.2,4,0.2,5.1,0.3,15.1 s0,11.2-0.2,15.1c0,2.5-0.5,5-1.3,7.3c-0.7,1.8-1.7,3.4-3.1,4.7c-1.3,1.4-2.9,2.4-4.7,3.1c-2.3,0.9-4.8,1.3-7.3,1.4 C238.9,199.2,237.7,199.3,227.7,199.3L227.7,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11798",
    className: "st6",
    d: "M227.6,149.6L227.6,149.6c-9.9,0-17.9,8-17.9,17.9c0,9.9,8,17.9,17.9,17.9h0.1 c9.9,0,17.9-8,17.9-17.9C245.5,157.6,237.5,149.6,227.6,149.6z M237.3,177.1c-2.6,2.6-6,4-9.7,4h0c-7.6-0.1-13.6-6.2-13.6-13.8 c0.1-7.4,6.1-13.5,13.5-13.6h0c7.6,0,13.7,6.1,13.7,13.7C241.3,171.1,239.8,174.5,237.3,177.1L237.3,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11799",
    className: "st6",
    d: "M247.4,144.3L247.4,144.3c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2h0 c1.8,0,3.2-1.4,3.2-3.2C250.6,145.7,249.2,144.3,247.4,144.3z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCampaignFlow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-campaign-flow.b54d5a0927976bba821e06f78584b756.svg";